import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Stack } from '@mui/material';
import { ComparedPortfolioSelector } from "../../portfolio-profile/components/ComparedPortfolioSelector";

export function ComparePortfoliosDialog({
    isOpen,
    setIsOpen,
}: {
    isOpen: boolean,
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>,
}) {
    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setIsOpen(false);
    };
    
    return (
        <>
            <Dialog
                open={isOpen}
                PaperProps={{
                    component: 'form',
                    onSubmit: handleSubmit,
                }}
            >
                <DialogTitle sx={{fontWeight: 'bold'}}>Compare portfolios</DialogTitle>
                <DialogContent>
                    <Stack direction="column" spacing={3}>
                        <ComparedPortfolioSelector />
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button
                        sx={{ fontWeight: "bold" }}
                        size="small"
                        variant="contained"
                        color="primary"
                        type="submit"
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}